import { isEqual } from "lodash";

// Create our own vuex LD plugin that watches for user change and update
export const launchdarklyPlugin = store => {
	store.watch(
		(state, getters) => getters["auth/user"],
		(newUser, oldUser) => {
			// Do a deep comparison
			if (!isEqual(newUser, oldUser)) {

        const {guid: key, properties: {firstName, lastName}, email, roles} = newUser;
        const user = {key, firstName, lastName, email, custom: {roles}}

				window.vm.$ld.identify({ newUser: user });
			}
		}
	);
};
